import { Link } from "react-router-dom";
import { FOOTER } from "@/constants/testIds";
import { Instagram, Music2, Linkedin, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid={FOOTER.wrapper}
      className="relative bg-[#1a3626] text-[#faf7f2] overflow-hidden"
    >
      <div className="pointer-events-none absolute -top-20 -right-20 w-[420px] h-[420px] rounded-full bg-[#c5a059]/8 blur-3xl" />

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 py-20 sm:py-24">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src="https://customer-assets.emergentagent.com/job_cashew-origin-story/artifacts/try0erao_image.png"
                alt="NAIJA Cashews logo"
                className="w-12 h-12 object-contain shrink-0"
              />
              <span className="font-serif-display text-[24px] text-[#faf7f2]">
                NAIJA Cashews
              </span>
            </div>
            <p className="mt-6 font-serif-display italic text-[28px] sm:text-[32px] text-[#c5a059] leading-tight max-w-md">
              Natural. Nutritious. Nigerian.
            </p>
            <p className="mt-5 text-[14px] leading-[1.8] text-[#faf7f2]/65 max-w-md">
              A premium African-origin food brand. Sourced in Imo & Abia,
              roasted with care, shipped from Berlin to the European pantry.
              Concept brand preview — product launch coming soon.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.24em] text-[#c5a059]">
              Explore
            </div>
            <ul className="mt-6 space-y-3 text-[14px] text-[#faf7f2]/80">
              {[
                { l: "Our Story", h: "/#story" },
                { l: "Products", h: "/#products" },
                { l: "Origin", h: "/#origin" },
                { l: "Journey", h: "/#journey" },
                { l: "Launch List", h: "/#signup" },
                { l: "Contact", h: "/#contact" },
              ].map((it) => (
                <li key={it.l}>
                  <a
                    href={it.h}
                    className="hover:text-[#c5a059] transition-colors"
                  >
                    {it.l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <div className="text-[11px] uppercase tracking-[0.24em] text-[#c5a059]">
              Connect
            </div>
            <ul className="mt-6 space-y-3 text-[14px] text-[#faf7f2]/80">
              <li>
                <a
                  data-testid={FOOTER.instagram}
                  href="https://instagram.com/naijacashews"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[#c5a059] transition-colors"
                >
                  <Instagram size={15} /> Instagram
                </a>
              </li>
              <li>
                <a
                  data-testid={FOOTER.tiktok}
                  href="https://tiktok.com/@naijacashews"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[#c5a059] transition-colors"
                >
                  <Music2 size={15} /> TikTok
                </a>
              </li>
              <li>
                <a
                  data-testid={FOOTER.linkedin}
                  href="https://linkedin.com/company/naijacashews"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[#c5a059] transition-colors"
                >
                  <Linkedin size={15} /> LinkedIn
                </a>
              </li>
              <li>
                <a
                  data-testid={FOOTER.emailGeneral}
                  href="mailto:info@naijacashews.com"
                  className="inline-flex items-center gap-2 hover:text-[#c5a059] transition-colors"
                >
                  <Mail size={15} /> info@naijacashews.com
                </a>
              </li>
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] uppercase tracking-[0.24em] text-[#c5a059]">
              Legal
            </div>
            <ul className="mt-6 space-y-3 text-[14px] text-[#faf7f2]/80">
              <li>
                <Link
                  data-testid={FOOTER.legalImprint}
                  to="/imprint"
                  className="hover:text-[#c5a059] transition-colors"
                >
                  Imprint
                </Link>
              </li>
              <li>
                <Link
                  data-testid="footer-legal-impressum"
                  to="/impressum"
                  className="hover:text-[#c5a059] transition-colors"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  data-testid={FOOTER.legalPrivacy}
                  to="/privacy"
                  className="hover:text-[#c5a059] transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  data-testid={FOOTER.legalTerms}
                  to="/terms"
                  className="hover:text-[#c5a059] transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
            </ul>
            <div className="mt-8 text-[11px] uppercase tracking-[0.24em] text-[#c5a059]">
              HQ
            </div>
            <div className="mt-3 text-[14px] text-[#faf7f2]/80">
              Berlin, Germany
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#c5a059]/15 flex flex-col sm:flex-row gap-4 justify-between items-start sm:items-center">
          <div className="text-[12px] text-[#faf7f2]/55">
            © {new Date().getFullYear()} NAIJA Cashews. All rights reserved.
          </div>
          <div className="text-[10px] uppercase tracking-[0.24em] text-[#faf7f2]/45">
            Made with origin pride · Lagos ↔ Berlin
          </div>
        </div>

        <div
          aria-hidden
          className="mt-16 text-center font-serif-display text-[72px] sm:text-[140px] lg:text-[200px] leading-none text-[#c5a059]/12 tracking-tight select-none"
        >
          NAIJA
        </div>
      </div>
    </footer>
  );
};
